export default function getSelectedMediaAssetIdsForChannel({
  channelId,
  productMediaByChannel = {},
  variantMediaByChannel = {},
  isVariantSync = false,
}) {
  const ids = new Set();

  if (!isVariantSync) {
    (productMediaByChannel[channelId] || []).forEach((assetId) => {
      ids.add(String(assetId));
    });
  }

  Object.keys(variantMediaByChannel[channelId] || {}).forEach((assetId) => {
    ids.add(String(assetId));
  });

  return [...ids];
}
